import { Typography } from "@packages/ds";
import styled from "styled-components";

import Toggle from "ds/Toggle";

export const Wrapper = styled.div`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 12px 0 24px;
  box-sizing: border-box;

  @media (max-width: 360px) {
    .search-wrapper {
      margin-top: 20px;
    }
  }
  @media (width<834px) {
    flex-direction: column;
    align-items: start;
    padding: 12px 0 0;
  }
`;

export const ProjectPageTitle = styled(Typography.Title)`
  flex: 1;

  @media (width< 834px) {
    flex: 0;
    padding-bottom: 8px;
  }
`;

export const ShowFiltersToggle = styled(Toggle)`
  width: 130px;
  display: flex;
  gap: 8px;
  font-size: 14px;
  padding: 2px 8px;
  box-sizing: content-box;
  color: var(--mode-text-neutral-default-weak);
  border-radius: 8px;

  &:hover,
  :focus {
    background-color: transparent !important;
    color: var(--mode-text-primary-default) !important;
  }

  &[aria-pressed="true"] {
    background-color: transparent !important;
    color: var(--mode-text-primary-default) !important;
  }
  @media (width<834px) {
    padding-left: 0;
  }
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  @media (width<834px) {
    position: relative;
    left: -8px;
  }
`;
